import { useCallback, useEffect, useState } from 'react'
import { getStorageReport, type StorageReport } from '@services/storageStats.js'

export function useStorageReport() {
  const [report, setReport] = useState<StorageReport | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      setReport(await getStorageReport())
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { report, loading, refresh }
}
